import { render } from "./SupplierCategoryTab.vue?vue&type=template&id=70fae628&scoped=true"
import script from "./SupplierCategoryTab.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryTab.vue?vue&type=script&lang=js"

import "./SupplierCategoryTab.vue?vue&type=style&index=0&id=70fae628&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fae628"]])

export default __exports__